import RouterBase from '../../../components/navigation/RouterBase'
import { URLAPP } from '../../../config'
import SarenvLogbook from './bitacora'
import SarenvProfiles from './perfiles'

export default function Ambientaciones() {
  return (
    <RouterBase
      items={[
        {
          component: <SarenvProfiles />,
          fullPath: URLAPP.sarenvProfile,
          nestedRouter: true
        }, 
        {
          component: <SarenvLogbook />,
          fullPath: URLAPP.sarenvLogbook,
        }
      ]}
    />
  )
}
